export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PostBanner.vue?vue&type=template&id=56b96bae&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/PostBanner.vue?vue&type=template&id=56b96bae&scoped=true&
// module id = 107
// module chunks = 0